import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  SelectPicker,
  Button,
  Icon,
  ButtonGroup,
  IconButton,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ManageProhibitedForm from './ManageProhibitedForm'
import TableManage from '../tableManage/TableManage'
import {
  getMasterReservedWord,
  saveMasterReservedWord,
  updateMasterReservedWord,
  deleteMasterReservedWord,
} from '../../redux/actions/masterReservedWord'

export default function ManageProhibitedWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [loading, setloading] = useState(false)

  const onSubmit = (data) => {
    console.log('data => ', data)
    let request = {
      word: data.prohibited,
    }
    handleSaveProhibited(request)
  }

  const handleSaveProhibited = async (request) => {
    startLoading()
    setloading(true)
    try {
      const response = await saveMasterReservedWord(request)

      if (response) {
        setFormSchema(response.forms)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const onSingleSubmitMain = (obj) => {
    // console.log('id', obj.ig)
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const handelGetSchemaDashboardMain = async (pagesize, pagenumber) => {
    setIsLoading(true)
    try {
      // const response = await getAllProject(5, 1)
      setFormSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const handleSearchProjectMain = async (pagesize, pagenumber, keyword) => {
    startLoading()
    setloading(true)
    try {
      console.log('search keyword', keyword)
      const response = await getMasterReservedWord(keyword)

      if (response) {
        setFormSchema(response.forms)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handelEditOnRow = (dataRow) => {
    console.log('handelEditOnRow 123 ', dataRow)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.manageForm.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema.manageForm && (
          <>
            <ManageProhibitedForm
              schema={formSchema.manageForm}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />

            <hr />

            <ButtonPanelWidget
              isEdit={true}
              isError={isError}
              buttonText={formSchema.manageForm.buttonText}
              onSave={handleSubmit(onSubmit)}
            />
          </>
        )}
      </Panel>

      <TableManage
        schema={formSchema.tableList}
        single={{
          enable: true,
        }}
        onSingleSubmit={onSingleSubmitMain}
        pagination={true}
        // onReload={handleSearchProjectMain}
        rowCanEdit={true}
        rowOnSubmit={handelEditOnRow}
        onSearchProject={handleSearchProjectMain}
        // onSelectProject={handleSelectProjectMain}
      />
    </>
  )
}
